function enc(s) {
    return encodeURIComponent(s).replace(/%20/g, '+');
}

// based on code from StackOverflow: http://bit.ly/1CqCWyJ . Leaves out the
// button you clicked, but seems to do the textboxes/checkboxes/hidden
// inputs you usually see in widgets. See
// http://malsup.com/jquery/form/comp/ for a list of the corner cases.
function serialize(form) {
    var pieces = [];
    for (var i = 0; i < form.elements.length; i++) {
        var field = form.elements[i];
        if (field.disabled || !field.name) continue;
        if (/^(file|reset|submit|button)$/i.test(field.type)) continue;
        if (/^(checkbox|radio)$/.test(field.type) && !field.checked) continue;

        if (field.type == 'select-multiple') {
            var opts = field.options;
            for (var j = 0; j < opts.length; j++) {
                var opt = opts[j];
                if (opt.selected) {
                    pieces.push([field.name, opt.value]);
                }
            }
        } else {
            pieces.push([field.name, field.value]);
        }
    }
    return pieces;
}

export function serializeToJson(form) {
    let ret = {};
    serialize(form).forEach(([k, v]) => ret[k] = v);
    return ret;
}

export function serializeToQuery(form) {
    return serialize(form).map(([k, v]) => `${k}=${enc(v)}`).join('&');
}
